
const isDevelopment = () => (
  typeof process === 'object' &&
  process.env &&
  process.env.NODE_ENV === 'development'
);

export default {
  isDevelopment
};



// WEBPACK FOOTER //
// ./src/lib/env.js